(() => {
  function addTemplateClass() {
    const main = document.querySelector('main.content-for-layout');
    if (!main || !main.dataset.template || !document.body) return;
    const handle = main.dataset.template.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    if (handle) document.body.classList.add('template-' + handle);
  }

  const translations = new Map(Object.entries({
    'Availability': 'Verfügbarkeit',
    'Price': 'Preis',
    'Sort': 'Sortieren',
    'Filter': 'Filtern',
    'Filters': 'Filter',
    'Clear': 'Löschen',
    'Clear all': 'Alle löschen',
    'Apply': 'Anwenden',
    'Remove': 'Entfernen',
    'Back': 'Zurück',
    'Close': 'Schließen',
    'Search': 'Suchen',
    'Cart': 'Warenkorb',
    'Your cart': 'Dein Warenkorb',
    'View cart': 'Warenkorb ansehen',
    'Checkout': 'Zur Kasse',
    'Check out': 'Zur Kasse',
    'Continue shopping': 'Weiter einkaufen',
    'Add to cart': 'In den Warenkorb legen',
    'Adding...': 'Wird hinzugefügt...',
    'Added to cart': 'Zum Warenkorb hinzugefügt',
    'Sold out': 'Ausverkauft',
    'Unavailable': 'Nicht verfügbar',
    'In stock': 'Auf Lager',
    'Out of stock': 'Nicht vorrätig',
    'Low stock': 'Niedriger Lagerbestand',
    'Featured': 'Empfohlen',
    'Best selling': 'Bestseller',
    'Alphabetically, A-Z': 'Alphabetisch, A–Z',
    'Alphabetically, Z-A': 'Alphabetisch, Z–A',
    'Price, low to high': 'Preis, niedrig bis hoch',
    'Price, high to low': 'Preis, hoch bis niedrig',
    'Date, old to new': 'Datum, alt bis neu',
    'Date, new to old': 'Datum, neu bis alt',
    'Featured products': 'Vorgestellte Produkte',
    'Recently viewed': 'Zuletzt angesehen',
    'You may also like': 'Das könnte dir auch gefallen',
    'Product information': 'Produktinformationen',
    'Product details': 'Produktdetails',
    'Product image': 'Produktbild',
    'Product total': 'Produkt insgesamt',
    'Product subtotal': 'Produktzwischensumme',
    'Quantity': 'Anzahl',
    'Subtotal': 'Zwischensumme',
    'Estimated total': 'Geschätzter Gesamtbetrag',
    'Discount': 'Rabatt',
    'Discount code': 'Rabattcode',
    'Shipping calculated at checkout.': 'Versandkosten werden beim Checkout berechnet.',
    'Taxes included.': 'Inkl. Steuern.',
    'Search results': 'Suchergebnisse',
    'No results found': 'Keine Ergebnisse gefunden',
    'View all': 'Alle ansehen',
    'Show more': 'Mehr anzeigen',
    'Show less': 'Weniger anzeigen',
    'Default': 'Standard',
    'Single': 'Einzeln',
    'Zoom out': 'Herauszoomen',
    'Account': 'Konto',
    'Orders': 'Bestellungen',
    'Profile': 'Profil',
    'Log in': 'Anmelden',
    'Sign in': 'Anmelden',
    'Log out': 'Abmelden',
    'Submit': 'Senden',
    'Email': 'E-Mail',
    'Email address': 'E-Mail-Adresse',
    'Name': 'Name',
    'Phone': 'Telefonnummer',
    'Comment': 'Kommentar',
    'Message': 'Nachricht',
    'Terms and Policies': 'Geschäftsbedingungen und Richtlinien',
    'Pagination': 'Seitennummerierung',
    'Previous': 'Zurück',
    'Next': 'Weiter',
    'Variant': 'Variante',
    'More': 'Mehr',
    'Open': 'Öffnen',
    'Password': 'Passwort',
    'Wrong password': 'Falsches Passwort',
    'Enter password': 'Passwort eingeben',
    'Enter using password': 'Mit Passwort anmelden',
    'Page not found': 'Seite nicht gefunden',
    'The link may be incorrect, or the page has been removed.': 'Der Link ist möglicherweise falsch oder die Seite wurde entfernt.',
    'Discover something new': 'Entdecke etwas Neues',
    'Collections': 'Kollektionen',
    'Featured collection': 'Vorgestellte Kollektion',
    'Opening soon': 'Bald geöffnet',
    'Sign up for our newsletter to be the first to know when we launch.': 'Melde dich für unseren Newsletter an und erfahre als Erstes, wann wir starten.',
    'Sign up': 'Anmelden'
  }));

  const attributes = ['aria-label', 'title', 'placeholder', 'data-option-name'];

  function normalize(value) {
    return value ? value.replace(/\s+/g, ' ').trim() : value;
  }

  function replaceExact(value) {
    const key = normalize(value);
    return translations.get(key) || value;
  }

  function translateTextNode(node) {
    const original = node.nodeValue;
    const key = normalize(original);
    if (!key) return;
    const translated = translations.get(key);
    if (translated) node.nodeValue = original.replace(key, translated);
  }

  function translateElement(element) {
    if (!(element instanceof Element)) return;

    attributes.forEach((attr) => {
      const current = element.getAttribute(attr);
      const translated = replaceExact(current);
      if (translated && translated !== current) element.setAttribute(attr, translated);
    });

    if (element.tagName === 'OPTION') {
      const translated = replaceExact(element.textContent);
      if (translated && translated !== element.textContent) element.textContent = translated;
    }
  }

  function walk(root) {
    if (!root) return;
    if (root.nodeType === Node.TEXT_NODE) {
      translateTextNode(root);
      return;
    }
    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_NODE) return;

    if (root.nodeType === Node.ELEMENT_NODE) translateElement(root);

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT);
    let node;
    while ((node = walker.nextNode())) {
      if (node.nodeType === Node.TEXT_NODE) translateTextNode(node);
      else translateElement(node);
    }
  }

  function run() {
    addTemplateClass();
    walk(document.body);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  const observer = new MutationObserver((mutations) => {
    addTemplateClass();
    for (const mutation of mutations) {
      mutation.addedNodes.forEach(walk);
      if (mutation.type === 'attributes') translateElement(mutation.target);
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: attributes
  });
})();
